module.exports = __webpack_public_path__ + "img/frame.4a6600ca.webp";